module.exports = __webpack_public_path__ + "assets/images/338afcd2f68bcc4114c494ae94b6070c.png";